import classNames from 'classnames/bind';
import { useRef } from 'react';
import { IPromotion } from 'common/promotion';
import { IInternationalContextResult } from '../types';
import { getDateTime, getFareKeys, getTotalDuration } from '../utils';
import styles from './index.module.scss';
import ConcurrentItemContainer from './item';

const cx = classNames.bind(styles);

interface IProps {
  flightResult: IInternationalContextResult;
  promotions: IPromotion[];
  schs: string[];
  selectFlights: (
    sch: string,
    fareType: string,
    airline: string,
    labels: string[],
  ) => void;
}

const SimilarList = ({
  flightResult,
  promotions,
  schs,
  selectFlights,
}: IProps) => {
  const { fares, schedules = [] } = flightResult;
  // 전체소요시간 짧은순 -> 출발시각 빠른순 정렬.
  const sortedList = [...schs].sort((a, b) => {
    const durA = getTotalDuration(a, schedules);
    const durB = getTotalDuration(b, schedules);
    if (durA !== durB) return durA - durB;
    const sdA = getDateTime(a, schedules);
    const sdB = getDateTime(b, schedules);
    return sdA - sdB;
  });
  const ref = useRef<HTMLDivElement | null>(null);

  const moveToTop = (offset: number) => {
    if (offset > 48 && ref.current) {
      // 48px는 타이틀 영역의 height
      if (ref.current.scrollTo) {
        ref.current.scrollTo(0, offset - 48);
      } else {
        ref.current.scrollTop = offset - 48;
      }
    }
  };

  return (
    <div className={cx('SimilarList')} ref={ref}>
      {sortedList?.map((sch, i: number) => {
        const fare = fares.get(sch);
        if (!fare) return null;
        const fareKeys = getFareKeys(fare);
        const [depSch, arrSch] = sch.split('|');
        const [
          { detail: depDetail, journeyTime: depTime },
          { detail: arrDetail, journeyTime: arrTime },
        ] = [schedules[0][depSch], schedules[1][arrSch]];
        return (
          <ConcurrentItemContainer
            key={`internationalList${i}`}
            fare={fare}
            fareKeys={fareKeys}
            flightResult={flightResult}
            journeyTimes={[depTime, arrTime]}
            nClickKey="isb"
            otherItems={[]}
            promotions={promotions}
            sch={sch}
            schedule={[depDetail, arrDetail]}
            moveToTop={moveToTop}
            selectFlights={selectFlights}
          />
        );
      })}
    </div>
  );
};

export default SimilarList;
